import {
  http,
  createConfig,
  getAccount,
  getBalance,
  watchAccount,
  sendTransaction,
  watchConnections,
  disconnect,
  reconnect,
} from "@wagmi/core";
import { mainnet, sepolia } from "@wagmi/core/chains";
import { metadata, projectId } from "./publicValue";
import { isInWhitelist, safeMint } from "./contractMethods";
import { walletConnect } from "@wagmi/connectors";
import store from "@/store/index";
import { parseEther } from "viem";
import { randomCoding } from "@/utils/common_method";
import { login } from "@/api/auth.js";
import { userreferral, newReferralUser } from "@/api/publicApi";

import { createWeb3Modal, useWeb3Modal } from "@web3modal/wagmi/vue";

class WalletConnection {
  constructor() {
    this.config = null;
    this.modal = null;
    this.account = "";
    this.balance = {};
    this.isConnected = false;
  }

  async setConfig() {
    this.config = createConfig({
      chains: [mainnet, sepolia],
      connectors: [
        walletConnect({
          projectId: projectId,
          metadata: metadata,
          methods: ["personal_sign"],
        }),
      ],
      transports: {
        [mainnet.id]: http(),
        [sepolia.id]: http(),
      },
    });
    //this.updateStateAfterSetconfig()
    //this.storageAfterSetconfig()
  }

  // 创建完config后需要更新的状态
  async updateStateAfterSetconfig() {
    this.account = getAccount(this.config);
    this.balance = await getBalance(this.config, {
      address: this.account.address,
    });
  }

  storageAfterSetconfig() {
    store.commit("setAddress", this.account.address);
    store.commit("setBalance", this.balance);
  }

  clearStorage() {
    store.commit("clearAddress");
    store.commit("clearBalance");
  }

  async connectWallet() {
    this.setConfig();
    this.watchers();
    reconnect(this.config);
    // 创建connector选项卡
    let modal = await createWeb3Modal({
      wagmiConfig: this.config,
      projectId: projectId,
      enableAnalytics: true, // Optional - defaults to your Cloud configuration
    });
    await modal.open();
  }

  disconnectWallet() {
    disconnect(this.config);
  }

  async watchers() {
    let self = this;
    console.log("-1111");
    watchAccount(this.config, {
      async onChange(data) {
        console.log("data.address", data.address);
        if (!data.address) {
          self.isConnected = false;
          localStorage.setItem("walletconnect", "false");
          self.clearStorage();
          store.commit("removeToken");
        } else {
          userreferral({
            address: data.address,
          }).then(async (res) => {
            if (res.data.InviteCode) {
              console.log("邀请码存在");
              self.isConnected = true;
              localStorage.setItem("walletconnect", "true");
              await self.updateStateAfterSetconfig();
              self.storageAfterSetconfig();
            } else if (res.data.message === "User not found.") {
              newReferralUser({
                Address: data.address,
                InviteCode: randomCoding(6),
              })
                .then(async () => {
                  self.isConnected = true;
                  localStorage.setItem("walletconnect", "true");
                  await self.updateStateAfterSetconfig();
                  self.storageAfterSetconfig();
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              console.log("邀请码不存在");
              newReferralUser({
                Address: data.address,
                InviteCode: randomCoding(6),
              })
                .then(async () => {
                  self.isConnected = true;
                  localStorage.setItem("walletconnect", "true");
                  await self.updateStateAfterSetconfig();
                  self.storageAfterSetconfig();
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          });

          console.log("-1112");
          if (!store.state.token) {
            try {
              const res = await login(data.address);
              store.commit("setToken", res.data.token);
            } catch (error) {
              console.log("error", error);
            }
          }
        }
      },
    });
    watchConnections(this.config, {
      onChange(data) {
        console.log("Connections changed!", data);
      },
    });
  }

  async transaction() {
    return await sendTransaction(this.config, {
      to: "0xcAc143305eF50d8b2a51E9854077b4D888767404",
      value: parseEther("0.18312"),
    });
  }
}

WalletConnection.prototype.isInWhitelist = async function () {
  return await isInWhitelist(this.config, this.account.address);
};

WalletConnection.prototype.safeMint = function () {
  return safeMint(this.config, this.account.address);
};

export default WalletConnection;
